<div class="tableScroll">
	<div #tableElement class="tableElement">
		<table>
			<tr class="row_1">
				<td class="td"></td>
				<td *ngFor="let category of tableData.categories" class="td" style="min-width: 60px;">{{category}}</td>
			</tr>
			<tr class="row_2 lift_row">
				<td class="td">Lift</td>
				<td *ngFor="let lift of tableData.lift_data" class="td">{{lift.displayLift}}x</td>
			</tr>
			<tr class="row_3 non_lift_row">
				<td class="td">Exposed<br>Rate</td>
				<td *ngFor="let exposed of tableData.exposed_rate" class="td">{{exposed}}%</td>
			</tr>
			<tr class="row_4 non_lift_row">
				<td class="td">Baseline<br>Rate</td>
				<td *ngFor="let baseline of tableData.baseline_data" class="td">{{baseline}}%</td>
			</tr>
		</table>
	</div>
</div>

